import { http } from "./api-config";
import store from "../store";

const apiClient = http(process.env.VUE_APP_ADMIN_SERVICE)

export default {
    async getStatisticsData(data) {
        const res = await apiClient.post('meeting_statistics', data)
        return res.data.data
    },
    async getUserList() {
        let headers = {};
        if (store.state.variables.cashUserList) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashUserList', true)
        const res = await apiClient.get('users', { headers })
        return res.data
    },
    async getRoleList() {
        let headers = {};
        if (store.state.variables.cashRoleList) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashRoleList', true)
        const res = await apiClient.get('roles', { headers })
        return res.data
    },
    async getRoleById(id) {
        let headers = {};
        if (
            store.state.variables.cashRoleId ===
            id
        ) {
            headers = { isSilentAPI: true };
        }
        store.commit("variables/setCashRoleId", id);
        const res = await apiClient.get(`roles/${id}`, { headers })
        return res.data
    },
    async createUser(userData) {
        const res = await apiClient.post('users', userData)
        return res.data
    },
    async createRole(roleData) {
        const res = await apiClient.post('roles', roleData)
        return res.data
    },
    async updateUser(userData) {
        const res = await apiClient.put('users', userData)
        return res.data
    },
    async updateRole(roleData) {
        const res = await apiClient.put('roles', roleData)
        return res.data
    },
    async getUserById(id) {
        let headers = {};
        if (
            store.state.variables.cashUserId ===
            id
        ) {
            headers = { isSilentAPI: true };
        }
        store.commit("variables/setCashUserId", id);
        const res = await apiClient.get(`users/${id}`, { headers })
        return res.data
    },
    async getUserByEmailId(useremail) {
        let headers = {};
        if (String(store.state.variables.cashUserByEmailId).toLowerCase() === String(useremail).toLowerCase()) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashUserByEmailId', useremail)
        const res = await apiClient.get(`userbyemail/${useremail}`, { headers })
        return res.data
    },
    async deleteUser(id) {
        const res = await apiClient.delete(`users/${id}`)
        return res.data
    },
    async deleteRole(id) {
        const res = await apiClient.delete(`roles/${id}`)
        return res.data
    },
    async deleteRole(id) {
        const res = await apiClient.delete(`roles/${id}`)
        return res.data
    },
    async changeUserPassword(data) {
        const res = await apiClient.put('changepassword', data)
        return res.data
    },
    async getActivitylogList(query) {
        const queryString = new URLSearchParams(query).toString()
        const res = await apiClient.get(`activitylogs?${queryString}`)
        return res.data
    },
    async getTopicFeedbacks(filter) {
        const res = await apiClient.post(`topic_feedbacks`, filter);
        return res.data.data;
    },
 async updateTenantGrouping(tenantData) {
        const res = await apiClient.put('update_tenant_grouping', tenantData)
        return res.data
    },
    async initiateResetMFA(id) {
        const res = await apiClient.get(`initiate_reset_token/${id}`)
        return res.data
    },
    async resetMFA(token) {
        const res = await apiClient.post(`resetmfa`, token )
        return res.data
    },
}